import React from "react";
import classNames from "classnames";
import classes from "./GenericCardView.scss";

const GenericCardView = ({ item }) => {
  const { label, subText, infoSubText } = item;
  const subLabel = subText || infoSubText;

  return (
    <div className={classNames(classes.card, classes.bulletView)}>
      <span className={classNames(classes.dot, "text-label")}>•</span>
      <div className={classes.contentContainer}>
        <span className={classNames(classes.title, "text-label")}>{label}</span>
        {/* {subLabel && (
          <span className={classNames(classes.subText, "text-body-s")}>
            {subLabel}
          </span>
        )} */}
      </div>
    </div>
  );
};

export default GenericCardView;
